module.exports = __webpack_public_path__ + "img/Network.2e78e683.svg";